// extracted by mini-css-extract-plugin
export var avatarContainer = "_41-1";
export var largeAvatarContainer = "_41-2";
export var smallAvatarContainer = "_41-0";